<template>
  <confirm-dialog-with-icon
    icon="deleteOutlined"
    :title="t('common.deleteContactTitle')"
    :description="t('common.confirmDeleteContact', { name: contact.name })"
    :accept-btn-text="t('common.remove')"
    :is-loading="!!isLoading"
    @yes="handleClose(true)"
    @no="handleClose(false)"
  />
</template>

<script lang="ts" setup>
import { safeInject, useRenderNotifier, closeDialogKey } from '@wui/common-library'
import { ref } from 'vue'


import { useStoreContacts } from '@/entities/contact'

import { ConfirmDialogWithIcon } from '@/shared/components/dialogs'
import { useLocalization } from '@/shared/composables/localization'
import { Contact } from '@/shared/types/api'

const { t } = useLocalization()

const props = defineProps<{
  contact: Contact
}>()

const isLoading = ref(false)

const { notifyError } = useRenderNotifier()
const storeContacts = useStoreContacts()
const closeModal = safeInject(closeDialogKey)
const handleClose = async (value: boolean) => {
  if (!value) {
    return closeModal(false)
  }

  try {
    isLoading.value = true
    await storeContacts.removeUserContact(props.contact.guid ?? props.contact.id, props.contact.groupIds?.[0] ?? '')
    closeModal(true)
  } catch (e) {
    notifyError((e as Error).message)
  } finally {
    isLoading.value = false
  }
}

</script>
